import type React from 'react';
import { memo } from 'react';

import { tv, type VariantProps } from 'tailwind-variants';

import cn from '../../../utils/cn';

const tableRow = tv({
  base: 'border-y border-gray-lightest first:border-none',
  variants: {
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
    condensed: {
      true: 'p-1.5',
      false: 'p-2.5',
    },
    isEven: {
      true: 'bg-gray-lightness',
      false: 'bg-white',
    },
    hover: {
      true: 'hover:border-y hover:border-gray-light hover:bg-primary-light/10',
      false: 'hover:bg-transparent',
    },
  },
  defaultVariants: {
    align: 'left',
    hover: true,
    condensed: false,
  },
});

type TableRowVariants = VariantProps<typeof tableRow>;

export interface TableRowProps extends TableRowVariants {
  className?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const TableRow = ({ className, align, condensed, hover, isEven, ...props }: TableRowProps) => {
  return (
    <tr
      className={cn(
        tableRow({ align, condensed, isEven, hover }),
        `
      data-[state=selected]:border-y
      data-[state=selected]:border-gray-light
      data-[state=selected]:bg-gray-lightest`,
        className
      )}
      {...props}
    />
  );
};
TableRow.displayName = 'TableRow';

export default memo(TableRow);
